import React from 'react';
import {
  Header,
  HeaderName,
  HeaderNavigation,
  HeaderMenuItem,
  HeaderGlobalBar,
  HeaderGlobalAction,
  SkipToContent,
  HeaderMenuButton,
  HeaderMenu,
  SideNav,
  SideNavMenu,
  SideNavMenuItem,
  SideNavLink,
  SideNavItems,
  HeaderContainer,
  SwitcherDivider,
} from 'carbon-components-react/lib/components/UIShell';
import Notification20 from '@carbon/icons-react/lib/notification/20';
import UserAvatar20 from '@carbon/icons-react/lib/user--avatar/20';
import AppSwitcher20 from '@carbon/icons-react/lib/app-switcher/20';
import { Link } from 'react-router-dom';

const IAGHeader = () => {

  const onClick = (closeMenu, link) => {

    // Update the current link that is in use
    var x = document.getElementsByClassName("bx--side-nav__link--current");
    var i;
    for (i = 0; i < x.length; i++) {
      x[i].classList.remove("bx--side-nav__link--current");
    }

    if(link) {
      document.getElementById(link).classList.add("bx--side-nav__link--current");
    }

    if(closeMenu) {
      closeMenu();
    }

    // Hide the side nav
    var sidenav = document.getElementsByClassName("bx--side-nav");
    if(sidenav && sidenav.length > 0) {
      sidenav[0].classList.remove("bx--side-nav--expanded");
    }
  };

  return (
    <HeaderContainer
      render={({ isSideNavExpanded, onClickSideNavExpand }) => (
        <>
          <Header aria-label="IBM Application Gateway Configuration" onClick={isSideNavExpanded === true? onClickSideNavExpand : null}>
            <SkipToContent />
            <HeaderMenuButton
              aria-label="Open menu"
              onClick={onClickSideNavExpand}
              isActive={isSideNavExpanded}
            />
            <HeaderName href="#" prefix="IBM Application Gateway Configuration">
            </HeaderName>
            <SideNav aria-label="Side navigation" expanded={isSideNavExpanded}>
              <SideNavItems>
                <SideNavLink id="homeLink" isActive={window.location.hash === undefined || window.location.hash.length < 3} onClick= {() => {onClick(onClickSideNavExpand, "homeLink");}} element={Link} to="/">Configuration YAML</SideNavLink>
                <SwitcherDivider/>
<SideNavLink id="advancedLink" isActive={window.location.hash && window.location.hash.indexOf("/advanced") > -1} onClick= {() => {onClick(onClickSideNavExpand, "advancedLink");}} element={Link} to="/advanced"><span id="advancedLinkText">Advanced</span></SideNavLink>
                <SideNavLink id="authorizationLink" isActive={window.location.hash && window.location.hash.indexOf("/authorization") > -1} onClick= {() => {onClick(onClickSideNavExpand, "authorizationLink");}} element={Link} to="/authorization"><span id="authorizationLinkText">Authorization</span></SideNavLink>
                <SideNavLink id="identityLink" isActive={window.location.hash && window.location.hash.indexOf("/identity") > -1} onClick= {() => {onClick(onClickSideNavExpand, "identityLink");}} element={Link} to="/identity"><span id="identityLinkText">Identity</span></SideNavLink>
                <SideNavLink id="loggingLink" isActive={window.location.hash && window.location.hash.indexOf("/logging") > -1} onClick= {() => {onClick(onClickSideNavExpand, "loggingLink");}} element={Link} to="/logging"><span id="loggingLinkText">Logging</span></SideNavLink>
                <SideNavLink id="policiesLink" isActive={window.location.hash && window.location.hash.indexOf("/policies") > -1} onClick= {() => {onClick(onClickSideNavExpand, "policiesLink");}} element={Link} to="/policies"><span id="policiesLinkText">Policies</span></SideNavLink>
                <SideNavLink id="resource_serversLink" isActive={window.location.hash && window.location.hash.indexOf("/resource_servers") > -1} onClick= {() => {onClick(onClickSideNavExpand, "resource_serversLink");}} element={Link} to="/resource_servers"><span id="resource_serversLinkText">Resource Servers</span></SideNavLink>
                <SideNavLink id="secretsLink" isActive={window.location.hash && window.location.hash.indexOf("/secrets") > -1} onClick= {() => {onClick(onClickSideNavExpand, "secretsLink");}} element={Link} to="/secrets"><span id="secretsLinkText">Secrets</span></SideNavLink>
                <SideNavLink id="serverLink" isActive={window.location.hash && window.location.hash.indexOf("/server") > -1} onClick= {() => {onClick(onClickSideNavExpand, "serverLink");}} element={Link} to="/server"><span id="serverLinkText">Server</span></SideNavLink>
                <SideNavLink id="servicesLink" isActive={window.location.hash && window.location.hash.indexOf("/services") > -1} onClick= {() => {onClick(onClickSideNavExpand, "servicesLink");}} element={Link} to="/services"><span id="servicesLinkText">Services</span></SideNavLink>
                <SideNavLink id="versionLink" isActive={window.location.hash && window.location.hash.indexOf("/version") > -1} onClick= {() => {onClick(onClickSideNavExpand, "versionLink");}} element={Link} to="/version"><span id="versionLinkText">Version</span></SideNavLink>

                <SwitcherDivider/>
                <SideNavLink id="docLink" href="https://ibm.biz/ibm-app-gateway" target="_blank">Documentation</SideNavLink>
              </SideNavItems>
            </SideNav>
          </Header>
          </>
      )}
    />
  );
}

export default IAGHeader;

